import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {Provider} from "react-redux";
import mainReducer from "./Components/store/reducers/main";
import zauneReducer from './Components/store/reducers/zaune';
import toreReducer from './Components/store/reducers/tore';
import pfortenReducer from './Components/store/reducers/pforten';
import gelaenderReducer from './Components/store/reducers/gelaender';
import vordaecherReducer from './Components/store/reducers/vordaecher';
import stahltreppenReducer from './Components/store/reducers/stahltreppen';
import {createStore, combineReducers, applyMiddleware} from "redux";
import logger from "redux-logger"; //show all actions and states in console.log()
import thunk from "redux-thunk"; //define async action creators

const reducers = combineReducers({
    mainReducer,
    zauneReducer,
    toreReducer,
    pfortenReducer,
    gelaenderReducer,
    vordaecherReducer,
    stahltreppenReducer
});

const store = createStore(reducers, applyMiddleware(logger, thunk));

ReactDOM.render(
    <Provider store={store} >
        <App />
    </Provider>,
    document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
